import * as React from "react";
import type { JSX } from "react";
import * as CompareSpecsStyles from "../styles/CompareSpecs";
import * as CompareLegendStyles from "../styles/CompareLegend";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon, {
    IconPlusCircle,
    IconTag,
    IconExclamationCircle,
} from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { type CompareV2LabelType, CompareV2Label } from "../../../utils/labels";

type IconType = "check" | "circle" | "dash" | "info" | "tag" | "add";

const legendItems: { id: string; name: string; icon: IconType }[] = [
    { id: "standard", name: "compareBodyLegendStandard", icon: "check" },
    { id: "optional", name: "compareBodyLegendOptional", icon: "circle" },
    { id: "notapplicable", name: "compareBodyLegendNotApplicable", icon: "dash" },
    { id: "exception", name: "compareBodyLegendException", icon: "info" },
    { id: "promotion", name: "compareBodyLegendPromotion", icon: "tag" },
    { id: "optionalpack", name: "compareBodyLegendOptionalPack", icon: "add" },
];

// TO DO: Update icons
export const getLegendIcon = (icon: IconType): JSX.Element => {
    if (icon === "check") {
        return (
            <IconWrapper iconColor="success">
                <Icon variant="check" />
            </IconWrapper>
        );
    } else if (icon === "circle") {
        return (
            <IconWrapper iconColor="grey6">
                <Icon variant="customize" />
            </IconWrapper>
        );
    } else if (icon === "dash") {
        return (
            <IconWrapper iconColor="grey6">
                <Icon variant="minus" />
            </IconWrapper>
        );
    } else if (icon === "info") {
        return (
            <IconWrapper iconColor="grey6" data-testid="iconExclamationCircle">
                <IconExclamationCircle />
            </IconWrapper>
        );
    } else if (icon === "tag") {
        return (
            <IconWrapper iconColor="red" data-testid="iconTag">
                <IconTag />
            </IconWrapper>
        );
    } else if (icon === "add") {
        return (
            <IconWrapper iconColor="grey3" data-testid="iconPlusCircle">
                <IconPlusCircle />
            </IconWrapper>
        );
    } else throw new Error("Unknown Legend Icon type");
};

const EquipmentLegend = (): JSX.Element => {
    return (
        <CompareSpecsStyles.Wrapper>
            <CompareSpecsStyles.Title>
                <CompareV2Label label="compareBodyEquipment" />
            </CompareSpecsStyles.Title>
            <CompareLegendStyles.Wrapper>
                {legendItems.map((item) => (
                    <CompareLegendStyles.Item key={`legend-${item.id}`}>
                        {getLegendIcon(item.icon)} <CompareV2Label label={item.name as CompareV2LabelType} />
                    </CompareLegendStyles.Item>
                ))}
            </CompareLegendStyles.Wrapper>
        </CompareSpecsStyles.Wrapper>
    );
};

export default EquipmentLegend;
